export const invertedMessages = {
  'Type more than 2 characters to see results.': 'CERTS_MIN_SEARCH_CHARACTERS',
  'Search by certification name or username': 'CERTS_SEARCH',
};
